var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-table", {
    attrs: { columns: _vm.columns, "data-source": _vm.baseData },
    scopedSlots: _vm._u([
      {
        key: "name",
        fn: function (text) {
          return _c("a", {}, [_vm._v(_vm._s(text))])
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }